import { differenceWith } from 'lodash';
import { InProgress, Submitted } from '@mummssoftware/utils/constants';
import { Resolved } from '../Context/constants';

// not used
// check if the CPP is in progress, or has been edited or resolved.
// removes bottom label if the problem was created but not edited.
export const checkIfEdited = (cpp: any) => {
  const { createdatetime, modifieddatetime, status } = cpp;
  return (
    status === InProgress ||
    ((status === Submitted || status === Resolved) &&
      createdatetime !== modifieddatetime)
  );
};

const taskComparator = (a: mumms.PatientCppTask, b: mumms.PatientCppTask) => {
  const idComparator = a.id === b.id;
  const whoComparator = a.who === b.who;
  const freqComparator = a.frequency === b.frequency;
  const periodComparator = a.period === b.period;
  // Active or Discontinued
  const statusComparator = a.status === b.status;
  if (
    idComparator &&
    whoComparator &&
    freqComparator &&
    periodComparator &&
    statusComparator
  ) {
    return true;
  }
  return false;
};

export const getTasksDiff = (
  initialCppTasks: mumms.PatientCppTask[] | null,
  cppTasks: mumms.PatientCppTask[] | null,
) => {
  if (initialCppTasks && cppTasks) {
    return differenceWith(cppTasks, initialCppTasks, taskComparator);
  }
  return null;
};
